export default "__VITE_ASSET__OpmeO6Ls__"